<template>
  <div class="ptStarka-menu">
    <div class="ptStarka-content">
      <div class="ptStarka-left">
        VayDễ
      </div>
      <div class="ptStarka-menubox">
        <div class="item" @click="selectMenu(1)">
          <p :class="step == 1 ? 'active-color' : ''">Chúng ta</p>
        </div>
        <div class="item" @click="selectMenu(2)">
          <p :class="step == 2 ? 'active-color' : ''">Giới thiệu doanh nghiệp</p>
        </div>
        <div class="item" @click="selectMenu(3)">
          <p :class="step == 3 ? 'active-color' : ''">Liên hệ với chúng tôi</p>
        </div>
        <div class="item" @click="selectMenu(4)">
          <p :class="step == 4 ? 'active-color' : ''">Chính sách bảo mật</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Menu",
  props: {
    step: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      index: 0,
    };
  },
  methods: {
    selectMenu(value) {
      this.index = value;
      if (value == this.step) {
        return;
      }
      switch (value) {
        case 1:
          this.$router.push({ path: "/" });
          break;
        case 2:
          this.$router.push({ path: "aboutUs" });
          break;
        case 3:
          this.$router.push({ path: "services" });
          break;
        case 4:
          this.$router.push({ path: "projects" });
          break;
        default:
          this.$router.push({ path: "/" });
          break;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.ptStarka-menu {
  position: relative;

  .ptStarka-content {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 312px;
    background: #121119;
    box-sizing: border-box;

    .ptStarka-left {
      display: flex;
      align-items: center;
      position: relative;
      margin-right: 80px;
      color: #FFFFFF;
      font-size: 30px;
      font-weight: 600;
    }
  }

  .ptStarka-menubox {
    display: flex;
    align-items: center;


    .item {
      margin-right: 20px;
      cursor: pointer;

      p {
        font-size: 20px;
        color: #FFFFFF;
        font-weight: 400;
      }

      .active-color {
        font-weight: 600;
        color: #E5D806;
      }
    }

    .item:nth-child(4) {
      margin-right: 0;
    }
  }
}
</style>
